const hasAllDocuments = (
  companyDocuments,
  requiredDocuments,
) => requiredDocuments.every((requiredDocument) => {
  const requiredYears = requiredDocument.years;
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  if (requiredYears === null) {
    // Check if there's at least one document with a null year
    return companyDocuments.some((document) => document.documentType
       === requiredDocument.code && !requiredDocument.documentDate);
  }
  // Create an array of required years
  const requiredYearsArray = Array.from(
    { length: requiredYears },
    (_, index) => currentYear - index,
  );

  // Check if there's at least one document for each required year
  return requiredYearsArray.every((year) => companyDocuments
    .some((document) => document.documentType === requiredDocument.code
          && document.documentDate
          && parseInt(document.documentDate.substring(0, 4), 10) === year));
});

export default hasAllDocuments;
